import React, { useMemo } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { useLocation } from "react-router-dom";
import WebForm from "./WebForm";
import TaxReturnForm from "./TaxReturnForm";
import TaxReturnPb from "./TaxReturnPb";
import TwoTaxReturn from "./TwoTaxReturn";
import ThreeTaxReturn from "./ThreeTaxReturn";
import StampsInventory from "../components/PbTaxReturn/StampsInventory";
import StampPacks from "../components/PbTaxReturn/StampPacks";
import NpmSales from "../components/PbTaxReturn/NPMSales";
import UnstampedPacks from "../components/PbTaxReturn/UnstampPacks";
import OffReservation from "../components/PbTaxReturn/OffReservation";
import PacksInventory from "../components/PbTaxReturn/PacksInventory";
import SalesTaxReport from "../components/PbTaxReturn/SalesTaxReport";
import TobaccoInvoiceReport from "../components/PbTaxReturn/TobaccoInvoiceReport";
import MotorFuelDistributorReport from "../components/PbTaxReturn/MotorFuelDistributorReport";
import TribalBusinessLicenseApplication from "../components/PbTaxReturn/TribalBusinessLicenseApplication";
import RenewalCritLicense from "../components/crit/RenewalCritLicense";
import SubmitInvoice from "../components/PbTaxReturn/SubmitInvoice";
import LiquorLicense from "../components/crit/LiquorLicense";
import { getPortalConfig } from "../config";
const Page = () => {
  const location = useLocation();

  // Use useMemo to stabilize the URL parameters
  const { tabFromUrl, itypeFromUrl, stypeFromUrl } = useMemo(() => {
    const queryParams = new URLSearchParams(location.search);
    const tabFromUrl = queryParams.get("tab") || "ProgramApplications";
    const itypeFromUrl = queryParams.get("itype");
    const stypeFromUrl = queryParams.get("stype")?.split("?")[0];

    return { tabFromUrl, itypeFromUrl, stypeFromUrl };
  }, [location.search]); // Only recompute when location.search changes

  // Create a stable parseData object
  const parseData = useMemo(() => ({
    iType: itypeFromUrl,
    sType: stypeFromUrl,
    activeComponent: tabFromUrl
  }), [itypeFromUrl, stypeFromUrl, tabFromUrl]);

  // Memoize the renderContent function to prevent unnecessary recreations
  const renderContent = useMemo(() => {
    if (itypeFromUrl?.toLowerCase() === "taxreturn") return <TaxReturnForm key={`taxreturn-${location.search}`} />;
    if (itypeFromUrl?.toLowerCase() === "taxreturnpb") return <TaxReturnPb key={`taxreturnpb-${location.search}`} />;
    if (itypeFromUrl?.toLowerCase() === "twoform") return <TwoTaxReturn key={`twoform-${location.search}`} parseData={parseData} />;
    if (itypeFromUrl?.toLowerCase() === "thirdform") return <ThreeTaxReturn key={`thirdform-${location.search}`} parseData={parseData} />;
    if (itypeFromUrl?.toLowerCase() === "stampinv") return <StampsInventory key={`thirdform-${location.search}`} parseData={parseData} />;
    if (itypeFromUrl?.toLowerCase() === "stamppacks") return <StampPacks key={`thirdform-${location.search}`} parseData={parseData} />;
    if (itypeFromUrl?.toLowerCase() === "npmsales") return <NpmSales key={`thirdform-${location.search}`} parseData={parseData} />;
    if (itypeFromUrl?.toLowerCase() === "unstampedpacks") return <UnstampedPacks key={`thirdform-${location.search}`} parseData={parseData} />;
    if (itypeFromUrl?.toLowerCase() === "offreservation") return <OffReservation key={`thirdform-${location.search}`} parseData={parseData} />;


    if (itypeFromUrl?.toLowerCase() === "retailerpacks") return <PacksInventory key={`thirdform-${location.search}`} parseData={parseData} />;
    if (itypeFromUrl?.toLowerCase() === "salestax") return <SalesTaxReport key={`thirdform-${location.search}`} parseData={parseData} />;
    if (itypeFromUrl?.toLowerCase() === "retailerreport") return <TobaccoInvoiceReport key={`thirdform-${location.search}`} parseData={parseData} />;
    if (itypeFromUrl?.toLowerCase() === "fuelreport") return <MotorFuelDistributorReport key={`thirdform-${location.search}`} parseData={parseData} />;
    if (itypeFromUrl?.toLowerCase() === "blrenewal") return <TribalBusinessLicenseApplication key={`thirdform-${location.search}`} parseData={parseData} />;

    if (itypeFromUrl?.toLowerCase() === "critrenew") return <RenewalCritLicense key={`thirdform-${location.search}`} parseData={parseData} />;
    if (itypeFromUrl?.toLowerCase() === "liquorlicense") return <LiquorLicense key={`thirdform-${location.search}`} parseData={parseData} />;



    // if (itypeFromUrl?.toLowerCase() === "stampinv") return <SubmitInvoice key={`thirdform-${location.search}`} parseData={parseData} />;

    


    console.log(itypeFromUrl?.toLowerCase())

    return <WebForm key={`webform-${location.search}`} parseData={parseData} />;
  }, [itypeFromUrl, parseData, location.search]);

  const currentYear = new Date().getFullYear();
  const portalConfig = getPortalConfig();
  console.log("portalConfig:", portalConfig);

  return (
    <div className="flex flex-col h-screen">
      <div className="fixed top-0 left-0 w-full z-50 bg-primary"><Header /></div>
      <div className="flex flex-1 mt-[72px]">
        <div className="fixed left-0 w-64 bg-white shadow-md h-[calc(100vh-72px)] overflow-y-auto hidden lg:block">
          <Sidebar />
        </div>
        <main className="flex-1 p-6 bg-gray-100 overflow-y-auto mt-[25px] lg:ml-64">
          {renderContent}
          {portalConfig?.name === "TERO" && (
            <div className="w-full text-center py-2 text-xs text-gray-500 mt-4">
              © {currentYear} Tribal D, Inc.
            </div>
          )}
        </main>
      </div>
    </div>
  );
};

export default Page;